import styled from "styled-components";

export const BackgroundWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-size: 400%;
`;
